// Subtle, opaque "moving in" background layer for otherwise-plain white pages.
// Renders a low-opacity happy photo behind content with a soft white wash so text stays readable.
const MOVE_IN_IMAGES = [
  "https://images.unsplash.com/photo-1758523671893-0ba21cf4260f?w=1600&q=80&auto=format&fit=crop",
  "https://images.unsplash.com/photo-1758523670991-ee93bc48d81d?w=1600&q=80&auto=format&fit=crop",
  "https://images.pexels.com/photos/7647206/pexels-photo-7647206.jpeg?auto=compress&cs=tinysrgb&w=1600",
  "https://images.unsplash.com/photo-1758523671087-b256bbbca475?w=1600&q=80&auto=format&fit=crop",
];

export function PageBackground({ variant = 0, opacity = 0.32 }) {
  const image = MOVE_IN_IMAGES[variant % MOVE_IN_IMAGES.length];
  return (
    <div className="fixed inset-0 -z-10 pointer-events-none overflow-hidden" aria-hidden="true" data-testid="page-background">
      <img src={image} alt="" className="w-full h-full object-cover" style={{ opacity }} />
      <div className="absolute inset-0 bg-gradient-to-b from-background/40 via-background/30 to-background/55" />
    </div>
  );
}

export { MOVE_IN_IMAGES };
